import { render } from "./NewVisit.vue?vue&type=template&id=b1994e82"
import script from "./NewVisit.vue?vue&type=script&lang=js"
export * from "./NewVisit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__